<template>
  <div>
    <div class="container">
      <div class="products-table">
        <div class="global-search">
          <div class="col-left">
            <i class="mr-2 icon-filter"></i> Filtrar resultados
          </div>
          <div class="col-right">
            <div class="clearfix search-bar">
              <input
                type="text"
                class="form-control"
                v-model="searchData"
                placeholder="Busque pelo produto, filtro ou equivalência"
                @keyup.enter="search"
              >
              <button type="button" class="btn btn-primary btn-search" @click="search">
                <i class="icon-search"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="table-contents">
          <div class="d-md-none">
            <div class="clearfix">
              <div class="filter-btn">
                <div class="js-filters-off">
                  <i class="mr-2 icon-filter"></i> Filtrar resultados
                </div>
                <div class="js-filters-on d-none">
                  <i class="mr-2 icon-angle-left"></i> Voltar
                </div>
              </div>
              <div class="clear-btn">
                <span class="light">
                  <i class="mr-2 icon-trash-o"></i> Limpar Filtros
                </span>
              </div>
            </div>
          </div>
          <div class="filters-group d-none d-md-block">
            <div class="item d-none d-md-block" @click="clearFilters">
              <a class="light clear-btn" @click="update++">
                <i class="mr-2 icon-trash-o"></i> Limpar Filtros
              </a>
            </div>

            <router-link to="/lancamentos" class="release-link">
              <div class="item">
                Últimos Lançamentos
                <span class="icon-release">
                  <i class="fas fa-chevron-circle-right"></i>
                </span>
              </div>
            </router-link>

            <car-filters
              :branched-filters="carsBranchedFilters"
              :filters-from-url="selectedVehicleFiltersFromURL"
              v-if="showCars && Object.keys(carsBranchedFilters).length"
              :key="carFilterKey"
              @update:cars="filteredCars = $event"
              @update:selectedCarFilters="setFilters"
              @update:listCarFilters="listCarFilters = $event, getWithFilters()"
            ></car-filters>
            <part-filters
              v-if="showParts && Object.keys(partsBranchedFilters).length"
              :filters-from-url="selectedPartFiltersFromURL"
              :key="partFilterKey"
              :branched-filters="partsBranchedFilters"
              @update:parts="filteredParts = $event"
              @update:selectedPartFilters="setFilters"
              @update:listPartFilters="listPartFilters = $event, getWithFilters()"
            ></part-filters>
          </div>

          <div class="products-group">
            <div class="item">
              <div class="row tabs-search">
                <div class="text-center col-md-6" :class="[showCars ? 'tab-active' : '']">
                  <span class="pointer tab-title" @click="toggleTab('cars')">
                    <span class="icon">
                      <i class="fas fa-car-side"></i>
                    </span>
                    Veículos ({{totalItems.cars}})
                  </span>
                </div>
                <div class="text-center col-md-6" :class="[showParts ? 'tab-active' : '']">
                  <span class="pointer tab-title" @click="toggleTab('parts')">
                    <span class="icon">
                      <i class="fas fa-tools"></i>
                    </span>
                    Peças ({{totalItems.parts}})
                  </span>
                </div>
              </div>
            </div>

            <div class="item d-none d-md-block" v-if="showCars">
              <span class="mr-2 light">Filtros selecionados ({{listCarFilters.length}})</span>
              <span
                v-for="(filter, index) in listCarFilters"
              >{{filter}} {{index + 1 < listCarFilters.length ? ' + ' : '' }}</span>
            </div>

            <div class="item d-none d-md-block" v-else>
              <span class="mr-2 light">Filtros selecionados ({{listPartFilters.length}})</span>
              <span
                v-for="(filter, index) in listPartFilters"
              >{{filter}} {{index + 1 < listPartFilters.length ? ' + ' : '' }}</span>
            </div>

            <parts-list v-if="showParts && !isLoadingParts" :parts="shownParts" :key="partListKey"></parts-list>
            <cars-list
              @update:vehicleTable="updateVehicleTable"
              v-if="showCars && !isLoadingVehicles"
              :cars="shownCars"
              :flip-year-from-arrow="orderBy.year_from[0] === 'asc' ? false : true"
              :flip-year-to-arrow="orderBy.year_to[0] === 'asc' ? false : true"
              :key="carListKey">
            </cars-list>
            <spinner v-if="showCars ? isLoadingVehicles : isLoadingParts"></spinner>

            <div class="item border-md-0">
              <div class="row" v-bind:class="{'d-none': (showCars ? isLoadingVehicles : isLoadingParts) || (showCars ? shownCars.length === 0 : shownParts.length === 0)}">
                <div
                  class="text-center col-md-6 text-md-left d-none d-md-block"
                >Exibindo {{showCars ? shownCars.length : shownParts.length}} de {{showCars ? totalItems.cars : totalItems.parts}} resultados para “{{$root.$data.searchData}}”</div>
                <div class="mt-3 col-md-6 mt-md-0" v-bind:class="{'d-none': totalPages <= 1}">
                  <pagination
                    ref="pager"
                    :pages="pages"
                    :current-page="currentPage"
                    :total-pages="showCars ? totalItems.cars : totalItems.parts"
                    :key="update"
                    @update:changePage="paginate"
                  >
                  </pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="diagonal-line"></div>
  </div>
</template>

<script>
import PartAPI from "@/api/part";
import VehicleAPI from "@/api/vehicle.vue";

import PartsList from "@/components/PartsList.vue";
import PartFilters from "@/components/PartFilters.vue";
import CarsList from "@/components/CarsList.vue";
import CarFilters from "@/components/CarFilters.vue";
import Pagination from "@/components/Pagination.vue";
import Spinner from "@/components/Spinner.vue";
import {
  escapeReservedUrlCharacters,
  removeSpecialCharacters
} from "@/utils/escape.js";

export default {
  name: "Products",
  data() {
    return {
      searchData: "",
      cars: [],
      orderBy: {
        year_from: ["asc", "desc"],
        year_to: ["asc", "desc"]
      },
      filteredCars: [],
      filteredParts: [],
      listCarFilters: [],
      parts: [],
      listPartFilters: [],
      showCars: true,
      showParts: false,

      update: 0,
      carFilterKey: 0,
      partFilterKey: 0,
      carListKey: 0,
      partListKey: 0,

      isLoadingVehicles: false,
      isLoadingParts: false,
      filters: "",
      currentTab: "cars",
      carFilters: {},
      partFilters: {},
      orderByYearFilter: [],

      pages: [],
      totalPages: 0,
      totalItems: {
        cars: 0,
        parts: 0
      },
      currentPage: 1,
      shownParts: [],
      shownCars: [],

      carsBranchedFilters: {},
      partsBranchedFilters: {},
      selectedProduct: "Veículos",
      selectedVehicleFiltersFromURL: [],
      selectedPartFiltersFromURL: []
    };
  },
  mounted() {
    this.getParts();

    if (this.$root.$data.parts.hits)
      this.filteredParts = this.$root.$data.parts.hits;

    if (this.$root.$data.cars.hits)
      this.filteredCars = this.$root.$data.cars.hits;

    if (this.totalItems.parts > this.totalItems.cars) {
      this.showParts = true;
      this.showCars = false;
      this.currentTab = "parts";
      this.selectedProduct = "Peças";
    }

    if (this.$root.$data.parts.hits || this.$root.$data.cars.hits) {
      this.paginate(1);
    }

    this.getFiltersFromURL();

    if (!this.$root.$data.searchData) {
      this.loadFilters();
    }

    this.update++;
  },
  components: {
    PartsList,
    CarsList,
    CarFilters,
    PartFilters,
    Pagination,
    Spinner
  },
  methods: {
    getParts() {
      if (this.$root.$data.parts.hits) {
        this.parts = this.$root.$data.parts.hits;
        this.shownParts = this.$root.$data.parts.hits;
        this.totalItems.parts = this.$root.$data.parts.total;
        this.partListKey++;
      }

      if (this.$root.$data.cars.hits) {
        this.shownCars = this.$root.$data.cars.hits;
        this.cars = this.$root.$data.cars.hits;
        this.totalItems.cars = this.$root.$data.cars.total;
        this.carListKey++;
      }

      this.searchData = this.$root.$data.searchData;

      if (this.$root.$data.searchData) {
        this.updateCarsFilters(this.$root.$data.searchData);
        this.updatePartsFilters(this.$root.$data.searchData);
      }
    },

    async search() {
      const query = removeSpecialCharacters({
        string: this.searchData,
        replace: "",
        except: ["."]
      });
      this.searchData = query;
      this.$root.$data.searchData = query;

      if (query) {
        try {
          this.resetData();
          this.clearFilters();

          this.updatePartsData(query, 1, true);
          this.updateCarsFilters(query);
          this.updatePartsFilters(query);

          await this.updateCarsData({ query, page: 1 });
        } catch (err) {
          console.log(err);
        } finally {
          if (this.$route.name === "Products") {
            this.paginate(1);
            this.update++;
            this.carFilterKey++;
            this.partFilterKey++;
          }
        }
      }
    },

    resetData() {
      this.totalItems = { cars: 0, parts: 0 };
      this.carFilters = [];
      this.partFilters = [];
      this.listPartFilters = [];
      this.listCarFilters = [];
      this.orderBy = {
        year_from: ["asc", "desc"],
        year_to: ["asc", "desc"]
      };
    },

    async updateCarsData({ query, page }) {
      try {
        const [column, order] = this.orderByYearFilter;
        this.isLoadingVehicles = true;
        let cars;

        if (query) {
          cars = await VehicleAPI.search(
            query,
            column,
            order,
            page,
            this.$root.$data.itemsPerPage,
            this.filters
          );
        } else {
          cars = await VehicleAPI.getWithFilters(
            column,
            order,
            page,
            this.$root.$data.itemsPerPage,
            this.filters
          );
        }

        this.$root.$data.cars = cars.data;
        this.filteredCars = cars.data.hits;
        this.shownCars = this.filteredCars;
        this.totalItems.cars = cars.data.total;
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoadingVehicles = false;
        this.carListKey++;
      }
    },

    async updateCarsFilters(query) {
      try {
        const [column, order] = this.orderByYearFilter;

        if (query) {
          const {
            data: { children }
          } = await VehicleAPI.getFilters(query, this.filters);
          this.carsBranchedFilters = children;
        } else {
          const {
            data: { children }
          } = await VehicleAPI.getWithFilters(
            column,
            order,
            query,
            this.filters
          );
          this.carsBranchedFilters = children;
        }
      } catch (err) {
        console.log(err);
      }
    },

    async updatePartsData(query, page, checkEquivalence = false) {
      try {
        this.isLoadingParts = true;

        let parts;

        if (query) {
          parts = await PartAPI.search(
            query,
            page,
            this.$root.$data.itemsPerPage,
            this.filters
          );
        } else {
          parts = await PartAPI.getWithFilters(
            page,
            this.$root.$data.itemsPerPage,
            this.filters
          );
        }

        this.totalItems.parts = parts.data.total;
        this.$root.$data.parts = parts.data;
        this.filteredParts = parts.data.hits;
        this.shownParts = this.filteredParts;

        if (checkEquivalence) {
          let find = parts.data.hits.find(
            item =>
              item.code_formatted.toUpperCase() === query.toUpperCase() ||
              item.original.equivalence_code_formatted.toUpperCase() ==
                this.$root.$data.searchData.toUpperCase() ||
              item.equivalencies.find(
                equiv =>
                  equiv.equivalence_code_formatted.toUpperCase() ==
                  this.$root.$data.searchData.toUpperCase()
              )
          );

          if (find) {
            this.$router.push(`/produto/${find.code}`);
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoadingParts = false;
        this.partListKey++;
      }
    },

    async updatePartsFilters(query) {
      try {
        if (query) {
          const {
            data: { children }
          } = await PartAPI.getFilters(query, this.filters);
          this.partsBranchedFilters = children;
        } else {
          const {
            data: { children }
          } = await PartAPI.getWithFilters(this.filters);
          this.partsBranchedFilters = children;
        }
      } catch (err) {
        console.log(err);
      }
    },

    paginate(page, shouldChangePage = true) {
      let totalItems = this.showCars
        ? this.totalItems.cars
        : this.totalItems.parts;

      const { paginate } = this.$refs.pager;
      [this.totalPages, this.pages, this.currentPage] = paginate(page, this.currentPage, totalItems, this.$root.$data.itemsPerPage, shouldChangePage, this.changePage)
    },

    async changePage(page) {
      try {
        if (this.showCars) {
          await this.updateCarsData({
            query: this.$root.$data.searchData,
            page
          });
        } else if (this.showParts) {
          await this.updatePartsData(this.$root.$data.searchData, page);
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.update++;
      }
    },

    setFilters(filters) {
      const formattedFilters = [];

      for (const [key, value] of Object.entries(filters)) {
        if (value) {
          formattedFilters.push(
            `filter[${key}]=${escapeReservedUrlCharacters(value)}`
          );
        }
      }

      this.filters = formattedFilters.join("&");
    },

    clearFilters() {
      this.selectedVehicleFiltersFromURL = [];
      this.selectedPartFiltersFromURL = [];
      this.filters = "";
      this.carFilterKey++;
      this.partFilterKey++;
    },

    async getWithFilters() {
      if (this.filters) {
        try {
          if (this.showCars) {
            await this.updateCarsData({ query: this.searchData, page: 1 });
          } else if (this.showParts) {
            await this.updatePartsData(this.searchData, 1);
          }
        } catch (err) {
          console.log(err);
        } finally {
          this.paginate(1, false);
          this.update++;
        }
      }
    },

    async updateVehicleTable(column) {
      if (this.shownCars.length) {
        this.orderByYearFilter = [column, this.orderBy[column][0]];

        try {
          await this.updateCarsData({
            query: this.$root.$data.searchData,
            page: this.currentPage,
            column,
            order: this.orderBy[column][0]
          });
        } catch (err) {
          console.log(err);
        } finally {
          this.paginate(this.currentPage);
          this.update++;
          this.orderBy[column].reverse();
        }
      }
    },

    async toggleTab(selectedTab) {
      if (selectedTab !== this.currentTab) {
        this.showCars = !this.showCars;
        this.showParts = !this.showParts;
        this.currentTab = selectedTab;
        this.listPartFilters, (this.listCarFilters = []);

        if (selectedTab === "parts") {
          this.selectedProduct = "Peças";
        } else {
          this.selectedProduct = "Veículos";
        }

        this.selectedVehicleFiltersFromURL = [];
        this.orderByYearFilter = [];

        this.filters = "";

        try {
          if (this.showCars) {
            await this.updateCarsData({
              query: this.$root.$data.searchData,
              page: 1
            });
          } else if (this.showParts) {
            await this.updatePartsData(this.$root.$data.searchData, 1);
          }
        } catch (err) {
          console.log(err);
        } finally {
          this.paginate(1);
          this.update++;
        }
      }
    },

    getFiltersFromURL() {
      const selectedProduct = this.$route.query.product;
      const carFilters = ['line', 'manufacturer', 'model', 'version', 'engine', 'year']
      const partFilters = ['category', 'manufacturer', 'model']

      if (this.$route.query && selectedProduct) {
        const filters = [];
        const filtersRef =
          selectedProduct === "Veículos" ? carFilters : partFilters;

        for (let [filterName, filterValues] of Object.entries(
          this.$route.query
        )) {
          if (filterName !== "product") {
            if (filtersRef.includes(filterName)) {
              filters.push({
                value: filterValues,
                name: filterName
              });
            }
          }
        }

        if (this.selectedProduct !== selectedProduct) {
          if (this.showCars) {
            this.toggleTab("parts");
          } else {
            this.toggleTab("cars");
          }
        }

        if (selectedProduct === "Veículos") {
          this.selectedVehicleFiltersFromURL = filters;
        } else {
          this.selectedPartFiltersFromURL = filters;
        }
      }
    },

    async loadFilters() {
      const {
        data: { children: partsFilters }
      } = await VehicleAPI.getAllFilters();
      this.carsBranchedFilters = partsFilters;

      const {
        data: { children: vehiclesFilters }
      } = await PartAPI.getAllFilters();
      this.partsBranchedFilters = vehiclesFilters;
    }
  },

  beforeDestroy() {
    this.$root.$data.searchData = "";
    this.$root.$data.cars = [];
    this.$root.$data.parts = [];
  }
};
</script>

<style scoped>
.tabs-search {
  color: #afafaf;
  font-size: 16px;
  margin-bottom: -3px;
}

.tab-active {
  color: #0056b3;
}

.pointer {
  cursor: pointer;
}

.clear-btn {
  cursor: pointer;
  color: #afafaf !important;
}

.release-link {
  color: #02375b !important;
  cursor: pointer;
}

.clear-btn:hover {
  color: #0056b3 !important;
}

.icon-release {
  position: relative;
  left: 45px;
  font-size: 14px;
}

@media (max-width: 800px) {
  .col-md-6:first-child {
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Products.vue